import * as jsxRuntime from "D:\\projects\\Supernode\\Argot\\ArgotAdmin\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment